import { FC, useState } from 'react';
import SidebarList from './sidebar-list';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { AgentModel } from '@/lib/models/agent.model';
import useThread from '@/hooks/use-thread.hook';
import Tab from './tab';
import TabHeader from './tab/tab-header';
import TabContent from './tab/tab-content';
import SidebarSearch from './sidebar-list/sidebar-search';

interface Props {
  onLoadAgent?: () => void;
  onClose?: () => void;
}

const searchAgents = (agents: AgentModel[], keyword?: string) => {
  if (!agents.length) {
    return [];
  }

  const safeKeyword = String(keyword).trim().toLowerCase();

  if (!safeKeyword) {
    return agents;
  }

  const fAgents = safeKeyword
    ? agents.filter(({ portal }) => {
        return [portal.description, portal.badge.title].some((val) =>
          String(val).toLowerCase().includes(safeKeyword)
        );
      })
    : agents;

  return fAgents;
};

const AgentTab: FC<Props> = ({ onLoadAgent, onClose }) => {
  const [keyword, setKeyword] = useState('');
  const { agents, isLoading } = useUserSettings();
  const { loadThread } = useThread();

  const handleKeywordChange = (value: string) => {
    setKeyword(value);
  };

  const handleLoadAgent = (agentId: string) => {
    loadThread(undefined, agentId);
    onLoadAgent?.();
  };

  const fAgents = isLoading ? [] : searchAgents(agents, keyword);

  const listItems = fAgents.map((agent) => {
    const {
      id,
      portal: { description, badge },
    } = agent;

    return {
      title: badge.title,
      content: description,
      key: `agent-${id}`,
      onClick: () => handleLoadAgent(id),
    };
  });

  return (
    <Tab onClose={onClose}>
      <TabHeader icon="assistant" title="Assistants" />
      <TabContent>
        <SidebarSearch
          name="agent-search"
          value={keyword}
          onChange={handleKeywordChange}
          placeholder="Search assistants"
        />
      </TabContent>
      <SidebarList isLoading={isLoading} items={listItems} emptyMessage="No assistants found" />
    </Tab>
  );
};

export default AgentTab;
